import { CopyIcon } from '@assets/icons';
import { IconButton, type IconButtonProps } from '@components/button';
import { Tooltip, TooltipProps } from '@components/tooltip';
import { delay } from '@helper-functions/delay';
import { useNotifications } from '@notifications/Notifications';
import { MouseEvent, useState } from 'react';

type CopyIconButtonProps = Omit<IconButtonProps, 'Icon'> & {
  value: string | number;
  size?: number;
  showValue?: boolean;
  label?: string;
  tooltipProps?: Partial<TooltipProps>;
};

export const CopyIconButton = ({
  value,
  size = 16,
  showValue,
  label,
  tooltipProps,
  ...props
}: CopyIconButtonProps) => {
  const { addNotification } = useNotifications();
  const [isCopied, setIsCopied] = useState(false);

  const copyToClipboard = async (event: MouseEvent) => {
    event.stopPropagation();
    event.preventDefault();
    try {
      setIsCopied(true);
      await navigator.clipboard.writeText(String(value));
      await delay(3000);
      setIsCopied(false);
    } catch (error) {
      let message = 'Unknown Error';
      if (error instanceof Error) message = error.message;
      addNotification({ type: 'error', text: message });
    }
  };

  return (
    <Tooltip
      title={isCopied ? 'Copied' : showValue ? value : label || 'Copy'}
      placement="bottom"
      {...tooltipProps}
    >
      <IconButton onClick={copyToClipboard} Icon={CopyIcon} size={size} {...props} />
    </Tooltip>
  );
};
